import {
  noCardProductRedirect,
} from '@americanexpress/rerouter';

export default function noMycaProductRedirect({
  state,
  locale,
  CARD_PRODUCT,
  CONSUMER_CHECKING_ACCOUNT,
  CONSUMER_SAVING_ACCOUNT,
}) {
  if (
    CARD_PRODUCT.length === 0
    && CONSUMER_CHECKING_ACCOUNT.length === 0
    && CONSUMER_SAVING_ACCOUNT.length === 0
  ) {
    const productsOrder = [];
    return noCardProductRedirect({ state, productsOrder, locale });
  }

  return {};
}
